import React from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate, useParams } from 'react-router-dom';

import { post } from '../../helpers/api_helper';
import { POST_ACCOUNT_ACTIVATED } from '../../helpers/url_helper';

import Auth_Img from './../../assets/img/auth_img.png';
import useMounted from '../../hooks/useMounted';
import { useTranslation } from 'react-i18next';

const Register = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const { id } = useParams()

    useMounted(() => {
        async function start() {
            if (id) {
                var api_res = await post(POST_ACCOUNT_ACTIVATED, { id: id });
                if (!api_res.status) {
                    navigate("/");
                }
            }
        }
        start();
    }, [id])

    return (
        <>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="Login" width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                            <div className='text-center'>
                                <h4 className="mb-3">{t('accountActivated.title')}</h4>
                                <p className="mb-4">{t('accountActivated.info')}</p>
                                <Link to="/" className='btn btn-primary btn-block1 mb-4 pl-4 pr-4'>{t('accountActivated.loginToYourAccount')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Register;